import { isErrorStatus } from '@audience-republic/audience-manager-shared/api/utils'
import type { CustomApiError } from '@audience-republic/audience-manager-shared/api/types'
import type { JWT } from './types'
import type { ArAxios } from '@/plugins/ar-axios'

export default (axios: ArAxios) => ({

  async fetchJWT(promoterOid: number): Promise<JWT> {
    const { data, status } = await axios.cn.get(`/promoter/${promoterOid}/oneschema-jwt`)
    if (isErrorStatus(status)) {
      const apiError: CustomApiError = {
        name: 'Fetch oneschema jwt error',
        message: `Error fetching oneschema jwt`,
        status,
      }
      throw apiError
    }
    return data
  },

})
